export default Object.freeze({
  ADDRESS: '00',
  GEOGRAPHY: '01',
  FREE_TEXT: '02',
});
